import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MarketDetailsResponse, MarketsService } from '@src/app/shared/backend/clients';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { DialogReasonComponent } from '@src/app/shared/components/dialog-reason/dialog-reason.component';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-view-market',
  templateUrl: './view-market.component.html',
  styleUrl: './view-market.component.scss',
  host: {
    class: 'app-view-market'
  },
  standalone: false,
  providers: [ConfirmationService]
})
export class ViewMarketComponent extends BaseViewComponent implements OnInit, OnDestroy {

  private readonly destroyedComponent$ = new Subject<void>();

  @ViewChild('dialog') dialog: DialogReasonComponent | undefined;

  public delete: boolean = false;
  public allowModifyMarket: boolean = false;
  public allowManageUsers: boolean = false;
  public allowManageRetailers: boolean = false;


  marketId: number = 0;
  marketUsersData: any;

  market: MarketDetailsResponse = {
    id: 0,
    name: '',
    code: ''
  };

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private marketsService: MarketsService
  ) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params
      .pipe(takeUntil(this.destroyedComponent$))
      .subscribe(async params => {
        this.marketId = Number(params['marketId']);

        if (this.marketId > 0) {
          await this.get();
        }
      });

    this.delete = await this.permissionService.hasActionPermissions(Actions.delete);
    this.allowModifyMarket = await this.permissionService.hasActionPermissions(Actions.modify_markets);
    this.allowManageUsers = await this.permissionService.hasActionPermissions(Actions.manage_market_users);
    this.allowManageRetailers = await this.permissionService.hasActionPermissions(Actions.manage_market_retailers);
  }

  override async get() {
    try {
      this.market = await firstValueFrom(
        this.marketsService.apiMarketsDetailsIdGet(
          this.marketId
        )
      );

      this.marketUsersData = this.market.users;
    } catch (error) {
      console.log('Error fetching market data:', error);
    }
  }

  manageMarketUsers() {
    this.router.navigate([`/markets/${this.marketId}/manage-users`]);
  }

  manageMarketRetailers() {
    this.router.navigate([`/markets/${this.marketId}/manage-retailers`]);
  }

  goToEditMarket() {
    this.router.navigate([`/markets/${this.marketId}/edit`]);
  }

  async showDeleteDialog(): Promise<void> {
    const deleteCheckResponses = await firstValueFrom(this.marketsService.apiMarketsDeleteCheckBatchPost([this.marketId]));

    this.dialog?.show(deleteCheckResponses);
  }

  async deleteMarket(doDelete: boolean): Promise<void> {
    if (doDelete) {
      await firstValueFrom(this.marketsService.apiMarketsDeleteIdDelete(this.marketId));
      this.router.navigate(['/markets']);
    }
  }

  ngOnDestroy(): void {
    this.destroyedComponent$.next();
    this.destroyedComponent$.complete();
  }
}
